import iconClose from './../images/icon-close.svg';

export default function PopupMessage({ title, message, onClose, className }: any) {
  return (
    <div
      className={`shadow-[0px_20px_36px_-8px_rgba(0,0,0,0.1),_0px_1px_2px_rgba(0,0,0,0.05)] bg-[#F4F3F0] rounded-xl md:mb-[30px] md:rounded-2xl py-[30px] px-6 md:p-10 md:w-[805px] mx-0 md:mx-auto transition-all duration-500 relative ${className}`}
    >
      <p className='text-[18px] md:text-[32px]'>{title}</p>
      <p className='text-sm md:text-xl mt-5'>{message}</p>
      <button
        className='w-6 md:w-[30px] h-6 md:h-[30px] absolute top-2 md:top-0 right-2 md:right-[-46px] md:shadow-[0px_20px_36px_-8px_rgba(0,0,0,0.1),_0px_1px_2px_rgba(0,0,0,0.05)] rounded-full bg-[#F4F3F0] hover:opacity-60 transition-all duration-300'
        onClick={onClose}
      >
        <img alt='close' src={iconClose} className='w-3 h-3 m-auto' />
      </button>
    </div>
  );
}
